import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { faHome, faFileInvoiceDollar } from "@fortawesome/pro-light-svg-icons"
import {
    COMPANY_ACCOUNTING_MEETING_SERVICE_ROUTE,
    COMPANY_ACCOUNTING_POS_ROUTE,
    COMPANY_ACCOUNTING_ROUTE,
    COMPANY_ACCOUNTING_SUBSCRIPTIONS_ROUTE,
    COMPANY_REPORTS_ROUTE,
} from "../../../../constants/routes"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../environment/envTypes"

export function CompanyReportNavItems() {
    return (
        <>
            <LocalizedStrict id="company-nav-item-home">
                <NavMenuItem icon={faHome} dest={COMPANY_REPORTS_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>
            <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.QA]}>
                <LocalizedStrict id="company-nav-item-accounting" attrs={{ title: true }}>
                    <NavMenuItemGroupWrapper
                        icon={faFileInvoiceDollar}
                        dest={COMPANY_ACCOUNTING_ROUTE}
                        title="Accounting"
                    >
                        <LocalizedStrict id="company-nav-item-pos">
                            <NavMenuSubItem route={COMPANY_ACCOUNTING_POS_ROUTE}>POS</NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-meeting-service">
                            <NavMenuSubItem route={COMPANY_ACCOUNTING_MEETING_SERVICE_ROUTE}>
                                Meeting service
                            </NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-subscriptions">
                            <NavMenuSubItem route={COMPANY_ACCOUNTING_SUBSCRIPTIONS_ROUTE}>
                                Subscriptions
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </NavMenuItemGroupWrapper>
                </LocalizedStrict>
            </MatchEnvironment>
        </>
    )
}
